<template lang="pug">
aside-modal(id="manageSubsidy", width="w-xxxl")
    span(slot="header-text")
        span(v-if="isContainData == true") Update
        span(v-else) Create
        | &nbsp;Subsidy

    div(slot="body")
        .container.p-a
            form(ui-jp='parsley',id="subsidyForm", data-vv-scope="subsidy", role="form")
            .loading.p-a(v-if="loading")
                .loading-spinner

            div.md-form-group(:class="{'invalid':errors.has('name')}")
                input.md-input(
                    type="text"
                    name="name"
                    v-model="subsidy.name"
                    data-vv-scope="subsidy"
                    v-validate="'required'"
                    :disabled="loading"
                )
                label Name
                span.parsley-errors-list(v-show="errors.has('name')") {{ errors.first('name') }}

            div.md-form-group(:class="{'invalid':errors.has('type')}")
                input.md-input(
                    type="text"
                    name="type"
                    v-model="subsidy.type"
                    data-vv-scope="subsidy"
                    v-validate="'required'"
                    :disabled="loading"
                )
                label Type
                span.parsley-errors-list(v-show="errors.has('type')") {{ errors.first('name') }}

            div.md-form-group
                label {{ trans('general.outlets') }}
                multiselect(
                    v-model="subsidy.outlets",
                    label="name",
                    track-by="id",
                    placeholder="Type to search",
                    :options="outletList",
                    :multiple="true",
                    :close-on-select="false",
                    :hide-selected="false",
                    :max-height="400",
                    :limit="30",
                    :loading="outlets_loading"
                    @search-change="loadOutlets"
                    :disabled="!canManageSubsidy"
                )
                span.md-input-msg {{ trans('general.leave_empty_if_applicable_to_all_outlets') }}

            div.md-form-group
                label Fuel Grade
                multiselect(
                    v-model="subsidy.grades",
                    label="name",
                    name="grades",
                    track-by="id",
                    placeholder="Type to search",
                    v-validate="'required'"
                    data-vv-scope="subsidy"
                    :options="fuelList",
                    :multiple="true",
                    :close-on-select="false",
                    :hide-selected="false",
                    :max-height="400",
                    :limit="30",
                    :class="{ 'parsley-error': errors.has('grades') }"
                    :loading="fuel_loading"
                    @search-change="loadFuels"
                    :disabled="!canManageSubsidy"
                )

                span.parsley-errors-list(v-show="errors.has('grades')")
                    | {{ errors.first('grades') }}

            //add toggle button for manual subsidy (is_manual_subsidy) by default it is true
            div.md-form-group
                label Options
                    div.form-group
                        p
                            label.md-switch.has-value
                                input(
                                    type="checkbox"
                                    name="is_manual_subsidy"
                                    v-model="subsidy.is_manual_subsidy"
                                    :disabled="loading"
                                )
                                i.indigo
                                | Manual Subsidy

    button.btn.btn-fw.primary(
        slot="footer",
        @click.prevent="submit()",
        :disabled="onLoading('save-subsidy')"
    )
        v-loading(loader="save-subsidy") Save
</template>

<script>
import { mapActions } from 'vuex';
import Auth from '@js/plugins/auth';

export default {
    data() {
        return {
            loading: false,
            isContainData: false,
            outletList: [],
            fuelList: [],
            outlets_loading: false,
            fuel_loading: false,
            subsidy: {
                name: '',
                type: '',
                grades: '',
                outlets: [],
                is_manual_subsidy: true,
            },
        };
    },

    computed: {
        canManageSubsidy() {
            return Auth.hasPermissionTo('franchise_manage_subsidy');
        },
    },

    created() {
        this.registerEvent();
    },

    mounted() {
        this.loadOutlets();
        this.loadFuels();
    },

    methods: {
        ...mapActions('subsidy', ['updateSubsidy', 'storeSubsidy']),
        showModal() {
            this.toggleModal('show');
        },
        hideModal() {
            this.toggleModal('hide');
        },
        toggleModal(action) {
            $('#manageSubsidy').modal(action);
        },
        registerEvent() {
            this.$bus.$on('manage_subsidy::display_form', data => {
                if (data != null) {
                    this.subsidy = {
                        ...data,
                        is_manual_subsidy:
                            data.is_manual_subsidy !== undefined
                                ? data.is_manual_subsidy
                                : true,
                    };
                } else {
                    this.subsidy = this.getEmptySubsidy();
                }

                this.isContainData = data != null;
                this.showModal();
            });
        },
        loadOutlets: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.outlets');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.outlets_loading = true;
            this.$http.get(api, options).then(response => {
                this.outletList = response.data.data;
                this.outlets_loading = false;
            });
        }, 500),
        loadFuels: _.debounce(function(query) {
            let api = Laroute.route('franchise.vue.fuels');
            let options = {
                params: {
                    query: query,
                    limit: this.multiselect_query_limit,
                },
            };

            this.fuel_loading = true;
            this.$http.get(api, options).then(response => {
                this.fuelList = response.data.data;
                this.fuel_loading = false;
            });
        }, 500),
        async submit() {
            this.errors.clear();
            this.hasValidationError = false;

            this.validateField(this.subsidy.name, 'name');
            this.validateField(this.subsidy.grades, 'grades');

            if (this.hasValidationError) return;

            const subsidy = Object.assign(
                _.pick(this.subsidy, [
                    'id',
                    'name',
                    'type',
                    'is_manual_subsidy',
                ]),
                {
                    outlets: this.subsidy.outlets.map(p => p.id),
                    grades: this.subsidy.grades.map(p => p.id),
                },
            );

            try {
                await this[
                    this.isContainData ? 'updateSubsidy' : 'storeSubsidy'
                ](subsidy);
                toastr.success('Successfully update subsidy details');
                this.$emit('refresh-table');
                this.hideModal();
            } catch (e) {
                this.showApiError(e);
            }
        },
        getEmptySubsidy() {
            return {
                id: null,
                name: null,
                outlets: [],
                grades: [],
                is_manual_subsidy: true,
            };
        },
        validateField(value, field) {
            if (
                _.isNull(value) ||
                value === '' ||
                value === undefined ||
                String(value).trim() === ''
            ) {
                this.errors.add({
                    field: field,
                    msg: `The ${_.replace(field, '_', ' ')} field is required`,
                });

                this.hasValidationError = true;

                return false;
            }

            return true;
        },
        clearValidation() {
            this.errors.clear();
            this.hasValidationError = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.alert-noty {
    background-color: rgb(255, 166, 50);
    color: rgb(90, 90, 90);
    padding: 15px;
    font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/setting/subsidy/form.vue